import React from "react";
import { Card } from "@material-ui/core";
import "bootstrap/dist/css/bootstrap.css";
import DashboardLineChart from "../../components/Chart/DashboardLineChart";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import * as actions from "../../actions";
import HOCSectionLoader from "../../components/HOC/HOCSectionLoader.jsx";
import { compose } from "redux";
import { Route, withRouter } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import NavbarNew from "../../components/NavBarNew/NavbarNew";
import Moment from "moment";
import { roundUpTransaction } from "../../utils/roundUpTransaction";
import AreYouSureAlert from "../../components/Alert/AreYouSureAlert";
import { getCookies } from "../../utils/getToken";
import Axios from "axios";
import { SERVER_URL } from "../../utils/config/constants";
import { NotificationManager } from "react-notifications";

const sendProps = (props) => {
  const { classes, ...rest } = props;
  return rest;
};
const styles = (theme) => ({
  heading: {
    color: "#ffffff",
  },
  paper: {
    backgroundColor: theme.palette.primary.main,
  },
  card: {
    color: theme.palette.secondary.main,
  },
});
let isLoading = true;
class ProviderBookingDetailsNew extends React.Component {
  constructor(props) {
    console.log("sdfghjkjhgfdsdfghjjhg", props);
    super(props);
    this.state = {
      loader: true,
      bookingDetailsDataPrev:
        this.props.history.location.state.bookingDetailsData,
      sub_status:
        this.props.history.location.state.bookingDetailsData.booking_data
          .sub_status,
      accept_booking_alert: false,
      reject_booking_alert: false,
      cancel_confirmed_booking_alert: false,
      on_my_way_alert: false,
      started_job_alert: false,
    };
  }
  componentDidMount() {
    // console.log("bookingDetailsData", this.state.bookingDetailsDataPrev);
  }

  checkIsBookingToday = () => {
    let todayDate = Moment(this.state.date).format("YYYY-MM-DD");
    // console.log("///////////////////////// booking details page today date ", todayDate);
    // console.log("///////////////////////// this.data.booking_data.booking_date ", this.state.bookingDetailsDataPrev.booking_data.booking_date);

    if (
      this.state.bookingDetailsDataPrev.booking_data.booking_date === todayDate
    ) {
      return true;
    } else {
      return false;
    }
  };

  acceptBookingStart = async () => {
    var authToken = getCookies();
    console.log("AUTH TOKEN", authToken);
    this.setState({
      showAlert: false,
    });
    try {
      const { data } = await Axios({
        method: "post",
        url: `${SERVER_URL}/booking/provider-accept`,
        data: {
          provider_booking_id: this.state.bookingDetailsDataPrev.id,
          booking_id: this.state.bookingDetailsDataPrev.booking_id,
          status: this.state.bookingDetailsDataPrev.status,
        },
        headers: {
          "x-auth-Token": authToken,
        },
      });
      console.log("ACCEPT booking data", data);
      if (data.status == "OK") {
        this.setState({
          loading: false,
        });
        NotificationManager.success(data.message, "Success");
        this.props.history.push("/provider/manage_bookings");
      } else {
        this.setState({
          loading: false,
        });
        NotificationManager.error(data.message, "Error");
        this.props.history.push("/provider/manage_bookings");
      }
    } catch (error) {
      console.log(
        "=========================== ACCEPT booking ERRORRRRRR",
        error
      );
    }
  };

  rejectBookingStart = async () => {
    var authToken = getCookies();
    console.log("AUTH TOKEN", authToken);
    this.setState({
      showAlert: false,
    });
    try {
      const { data } = await Axios({
        method: "post",
        url: `${SERVER_URL}/booking/provider-reject`,
        data: {
          provider_booking_id: this.state.bookingDetailsDataPrev.id,
          booking_id: this.state.bookingDetailsDataPrev.booking_id,
          status: this.state.bookingDetailsDataPrev.status,
        },
        headers: {
          "x-auth-Token": authToken,
        },
      });
      console.log("REJECT booking data", data);
      if (data.status == "OK") {
        this.setState({
          loading: false,
        });
        NotificationManager.success(data.message, "Success");
        this.props.history.push("/provider/manage_bookings");
      } else {
        this.setState({
          loading: false,
        });
        NotificationManager.error(data.message, "Error");
        this.props.history.push("/provider/manage_bookings");
      }
    } catch (error) {
      console.log(
        "=========================== REJECT booking ERRORRRRRR",
        error
      );
    }
  };

  cancelConfirmedBookingStart = async () => {
    var authToken = getCookies();
    console.log("AUTH TOKEN", authToken);
    this.setState({
      showAlert: false,
    });
    try {
      const { data } = await Axios({
        method: "post",
        url: `${SERVER_URL}/booking/provider-cancel`,
        data: {
          provider_booking_id: this.state.bookingDetailsDataPrev.id,
          booking_id: this.state.bookingDetailsDataPrev.booking_id,
          status: this.state.bookingDetailsDataPrev.status,
        },
        headers: {
          "x-auth-Token": authToken,
        },
      });
      console.log("CANCEL booking data", data);
      if (data.status == "OK") {
        this.setState({
          loading: false,
        });
        NotificationManager.success(data.message, "Success");
        this.props.history.push("/provider/manage_bookings");
      } else {
        this.setState({
          loading: false,
        });
        NotificationManager.error(data.message, "Error");
        this.props.history.push("/provider/manage_bookings");
      }
    } catch (error) {
      console.log(
        "=========================== CANCEL booking ERRORRRRRR",
        error
      );
    }
  };

  updateSubstatus = async (booking_id, sub_status) => {
    var authToken = getCookies();
    console.log("booking_id", booking_id);
    console.log("sub_status", sub_status);
    this.setState({
      on_my_way_alert: false,
      started_job_alert: false,
    });
    try {
      const { data } = await Axios({
        method: "post",
        url: `${SERVER_URL}/booking/provider-update-substatus`,
        data: {
          booking_id: booking_id,
          status: sub_status,
        },
        headers: {
          "x-auth-Token": authToken,
        },
      });
      console.log("UPDATE SUBSTATUS", data);
      if (data.status == "OK") {
        if (sub_status == "on-my-way") {
          this.setState({
            sub_status: "on-my-way",
          });
        } else {
          this.setState({
            sub_status: "started-job",
          });
        }
        NotificationManager.success(data.message, "Success");
        // this.props.history.push('/provider/manage_bookings')
      } else {
        this.setState({
          loading: false,
        });
        NotificationManager.error(data.message, "Error");
        // this.props.history.push('/provider/manage_bookings')
      }
    } catch (error) {
      console.log(
        "=========================== CANCEL booking ERRORRRRRR",
        error
      );
    }
  };

  render() {
    var card = {
      border: "1px solid #eee",
      boxShadow: "1px 1px 20px #ddd",
      borderRadius: "10px",
      marginBottom: 20,
      padding: 20,
    };

    var card1 = {
      border: "1px solid #eee",
      boxShadow: "1px 1px 20px #ddd",
      borderRadius: "10px",
      marginBottom: 20,
      padding: 20,
      height: "359px",
    };

    var card2 = {
      border: "1px solid #eee",
      boxShadow: "1px 1px 20px #ddd",
      borderRadius: "10px",
      marginBottom: 20,
      padding: 20,
      height: "395px",
    };
    var cardHeading = {
      backgroundColor: "#0078ff",
      color: "white",
      fontWeight: "600",
      padding: "5px 20px",
      borderRadius: 50,
      fontSize: 18,
      marginBottom: 25,
      marginBottom: 20,
    };
    var infoHead = {
      color: "green",
      fontSize: 20,
      fontWeight: "700",
      marginBottom: 0,
    };

    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let originalDate =
      this.state.bookingDetailsDataPrev.booking_data.booking_date;
    console.log("originalDate", originalDate);
    let year = originalDate.substring(0, 4);
    let month = Number(originalDate.substring(5, 7)) - 1;
    let date = originalDate.substring(8, 10);
    let formattedDate = monthNames[month] + " " + date + ", " + year;
    return (
      <div className="tz-2-com tz-2-main">
        <NavbarNew
          title="Booking Details"
          goback={() => this.props.history.goBack(null)}
        />
        <div style={{ paddingBottom: "25px" }} className="db-list-com">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: -40,
            }}
          />

          <div
            id="booking_details2"
            style={{
              width: "100%",
              display: "flex",
            }}
          >
            <div
              style={{
                width: "50%",
                // backgroundColor: 'lightgreen',
                display: "flex",
                flexDirection: "column",
                padding: 10,
              }}
            >
              <div style={card}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                    width: "100%",
                  }}
                >
                  <p style={cardHeading}>Booking Info</p>
                  {this.state.bookingDetailsDataPrev.status ===
                    "rescheduled-user" && (
                    <div style={{}}>
                      <p
                        style={{
                          color: "orange",
                          fontSize: 15,
                          fontWeight: "bold",
                        }}
                      >
                        Rescheduled by User
                      </p>
                    </div>
                  )}
                  {this.state.bookingDetailsDataPrev.status ===
                    "rescheduled-provider" && (
                    <div style={{}}>
                      <p
                        style={{
                          color: "orange",
                          fontSize: 15,
                          fontWeight: "bold",
                        }}
                      >
                        Rescheduled by You
                      </p>
                    </div>
                  )}
                  {this.state.bookingDetailsDataPrev.status === "closed" && (
                    <div style={{}}>
                      <p
                        style={{
                          color: "green",
                          fontSize: 15,
                          fontWeight: "bold",
                        }}
                      >
                        Booking Completed
                      </p>
                    </div>
                  )}
                  {(this.state.bookingDetailsDataPrev.status === "completed" ||
                    this.state.bookingDetailsDataPrev.status === "denied") && (
                    <div style={{}}>
                      <p
                        style={{
                          color: "orange",
                          fontSize: 15,
                          fontWeight: "bold",
                        }}
                      >
                        Pending Approval
                      </p>
                    </div>
                  )}
                  {this.state.bookingDetailsDataPrev.status ===
                    "denied-confirmed" && (
                    <div style={{}}>
                      <p
                        style={{
                          color: "red",
                          fontSize: 15,
                          fontWeight: "bold",
                        }}
                      >
                        Completion Denied
                      </p>
                    </div>
                  )}
                  {
                    ((this.state.bookingDetailsDataPrev.status ===
                      "confirmed" &&
                      this.state.bookingDetailsDataPrev.status ===
                        "revised-price") ||
                      !this.state.sub_status ||
                      this.state.sub_status == "on-my-way") &&
                    this.checkIsBookingToday() &&
                    // <div>
                    // {
                    this.state.bookingDetailsDataPrev.status ===
                      "revised-price" ? (
                      <p
                        style={{
                          color: "orange",
                          fontSize: 15,
                          fontWeight: "bold",
                        }}
                      >
                        Revised Price Pending
                      </p>
                    ) : null
                    // }
                    // </div>
                  }
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <p style={{ ...infoHead, marginBottom: 0 }}>
                    {formattedDate}
                  </p>
                  {((this.state.bookingDetailsDataPrev.status === "confirmed" &&
                    this.state.bookingDetailsDataPrev.status ===
                      "revised-price") ||
                    !this.state.sub_status ||
                    this.state.sub_status == "on-my-way" ||
                    this.state.sub_status == "started-job") &&
                  this.checkIsBookingToday() ? (
                    <div>
                      {this.state.bookingDetailsDataPrev.status !==
                      "revised-price" ? (
                        <p
                          style={{
                            textDecoration: "underline",
                            color: "#0078ff",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            this.props.history.push(
                              `/provider/propose_new_price/${this.state.bookingDetailsDataPrev.id}`,
                              {
                                bookingDetails:
                                  this.state.bookingDetailsDataPrev,
                                prev_route: "details_route",
                              }
                            )
                          }
                        >
                          {this.state.bookingDetailsDataPrev.status ===
                          "confirmed"
                            ? "Need Price Change?"
                            : ""}
                        </p>
                      ) : null}
                    </div>
                  ) : null}
                </div>

                <p
                  style={{
                    fontSize: 18,
                  }}
                >
                  {this.state.bookingDetailsDataPrev.booking_data.booking_slot}
                </p>
                <p
                  style={{
                    fontSize: 18,
                    marginBottom: 0,
                    fontWeight: "bold",
                  }}
                >
                  Booking#{" "}
                  <span style={{ color: "#0078ff", fontWeight: "bold" }}>
                    {
                      this.state.bookingDetailsDataPrev.booking_data
                        .booking_number
                    }
                  </span>
                </p>
                <p
                  style={{
                    fontSize: 18,
                    fontWeight: "bold",
                    marginBottom: 0,
                  }}
                >
                  {this.state.bookingDetailsDataPrev.taskData.full_name.service}{" "}
                  (
                  {
                    this.state.bookingDetailsDataPrev.taskData.full_name
                      .master_category
                  }{" "}
                  /{" "}
                  {
                    this.state.bookingDetailsDataPrev.taskData.full_name
                      .category
                  }
                  )
                </p>
                <p
                  style={{
                    fontSize: 18,
                  }}
                >
                  Description:{" "}
                  {this.state.bookingDetailsDataPrev.taskData.description}
                </p>
                <p
                  style={{
                    fontSize: 18,
                    marginBottom: 0,
                  }}
                >
                  Booking Type:{" "}
                  {this.state.bookingDetailsDataPrev.taskData.service_type} |{" "}
                  {this.state.bookingDetailsDataPrev.taskData.booking_type}
                </p>
                <p
                  style={{
                    fontSize: 18,
                    marginBottom: 0,
                  }}
                >
                  Booking Unit:{" "}
                  {
                    this.state.bookingDetailsDataPrev.booking_data
                      .booking_quantity
                  }
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                  >
                    Booking Value: $
                    {roundUpTransaction(
                      this.state.bookingDetailsDataPrev.provider_booking_value
                    )}
                  </p>
                </div>
              </div>
              <div id="additional_font" style={card}>
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: 4,
                    }}
                  >
                    <p id="font" style={cardHeading}>
                      Additional Info
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <p
                      id="font"
                      style={{
                        fontSize: 18,
                      }}
                    >
                      <span id="font" style={{ fontWeight: "bold" }}>
                        Will be Home
                      </span>{" "}
                      -{" "}
                      {this.state.bookingDetailsDataPrev.home_stay == 2
                        ? "No"
                        : "Yes"}
                    </p>
                    {this.state.bookingDetailsDataPrev.home_stay == 2 ? (
                      <p
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                          color: "#0078ff",
                        }}
                        onClick={() =>
                          this.setState({
                            read_instruction: !this.state.read_instruction,
                          })
                        }
                      >
                        {this.state.read_instruction
                          ? "Hide Instruction"
                          : "Read Instruction"}
                      </p>
                    ) : null}
                  </div>
                  {this.state.read_instruction ? (
                    <p
                      style={{
                        fontSize: 18,
                      }}
                    >
                      {
                        this.state.bookingDetailsDataPrev.booking_data
                          .home_instruction
                      }
                    </p>
                  ) : null}
                </div>
                <div
                  style={{
                    marginTop: 20,
                  }}
                >
                  <p
                    style={{
                      fontSize: 18,
                    }}
                  >
                    <span id="font" style={{ fontWeight: "bold" }}>
                      Notes / Instructions
                    </span>
                  </p>
                  <p
                    style={{
                      fontSize: 18,
                    }}
                  >
                    {
                      this.state.bookingDetailsDataPrev.booking_data
                        .instructions
                    }
                  </p>
                </div>
                <div
                  style={{
                    marginTop: 25,
                  }}
                >
                  <p
                    style={{
                      fontSize: 18,
                    }}
                  >
                    <span id="font" style={{ fontWeight: "bold" }}>
                      Uploaded Photos
                    </span>
                  </p>
                  <div
                    id="add_photo"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                      // borderRadius: "10px",
                      // overflow: "auto",
                      // overflowY: "hidden",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                        // padding: "5px",
                        // border: "1px solid #eee",
                        borderRadius: "10px",
                        // padding: "2px 0px 2px 0px",
                      }}
                    >
                      {this.state.bookingDetailsDataPrev.booking_data
                        .booking_img1 ? (
                        <img
                          src={
                            this.state.bookingDetailsDataPrev.booking_data
                              .booking_img1
                          }
                          style={{
                            height: "7rem",
                            width: "7rem",
                            borderRadius: 10,
                            margin: 5,
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "7rem",
                            width: "7rem",
                            borderRadius: 10,
                            margin: 5,
                            backgroundColor: "#ddd",
                          }}
                        >
                          <p
                            style={{
                              textAlign: "center",
                            }}
                          >
                            No Photo Added
                          </p>
                        </div>
                      )}
                      {this.state.bookingDetailsDataPrev.booking_data
                        .booking_img2 ? (
                        <img
                          src={
                            this.state.bookingDetailsDataPrev.booking_data
                              .booking_img2
                          }
                          style={{
                            height: "7rem",
                            width: "7rem",
                            borderRadius: 10,
                            margin:5
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "7rem",
                            width: "7rem",
                            borderRadius: 10,
                            backgroundColor: "#ddd",
                            margin: 5
                          }}
                        >
                          <p
                            style={{
                              textAlign: "center",
                            }}
                          >
                            No Photo Added
                          </p>
                        </div>
                      )}
                      {this.state.bookingDetailsDataPrev.booking_data
                        .booking_img3 ? (
                        <img
                          src={
                            this.state.bookingDetailsDataPrev.booking_data
                              .booking_img3
                          }
                          style={{
                            height: "7rem",
                            width: "7rem",
                            borderRadius: 10,
                            margin:5
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "7rem",
                            width: "7rem",
                            borderRadius: 10,
                            backgroundColor: "#ddd",
                            margin: 5
                          }}
                        >
                          <p
                            style={{
                              textAlign: "center",
                            }}
                          >
                            No Photo Added
                          </p>
                        </div>
                      )}
                      {this.state.bookingDetailsDataPrev.booking_data
                        .booking_img4 ? (
                        <img
                          src={
                            this.state.bookingDetailsDataPrev.booking_data
                              .booking_img4
                          }
                          style={{
                            height: "7rem",
                            width: "7rem",
                            borderRadius: 10,
                            margin: 5
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "7rem",
                            width: "7rem",
                            borderRadius: 10,
                            backgroundColor: "#ddd",
                            margin:5
                          }}
                        >
                          <p
                            style={{
                              textAlign: "center",
                            }}
                          >
                            No Photo Added
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>{" "}


              {this.state.bookingDetailsDataPrev.status === "denied" ||
              this.state.bookingDetailsDataPrev.status ===
                "denied-confirmed" ? (
                <div style={card}>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p style={cardHeading}>Rejection Info</p>
                    </div>
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <p style={{ fontSize: 18 }}>
                      <span style={{ fontWeight: "bold" }}>
                        Notes / Instructions
                      </span>
                    </p>
                    <p style={{ fontSize: 18 }}>
                      {this.state.bookingDetailsDataPrev.booking_data
                        .reject_reason || "No notes"}
                    </p>
                  </div>
                  <div style={{ marginTop: 65 }}>
                    <p style={{ fontSize: 18 }}>
                      <span style={{ fontWeight: "bold" }}>
                        Uploaded Photos
                      </span>
                    </p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        alignItems: "center",
                        borderRadius: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",

                          justifyContent: "space-evenly",
                          width: "100%",
                          alignItems: "center",
                        }}
                      >
                        {this.state.bookingDetailsDataPrev.booking_data
                          .reject_img1 ? (
                          <img
                            src={
                              this.state.bookingDetailsDataPrev.booking_data
                                .reject_img1
                            }
                            style={{
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                              backgroundColor: "#ddd",
                            }}
                          >
                            <p style={{ textAlign: "center" }}>
                              No Photo Added
                            </p>
                          </div>
                        )}
                        {this.state.bookingDetailsDataPrev.booking_data
                          .reject_img2 ? (
                          <img
                            src={
                              this.state.bookingDetailsDataPrev.booking_data
                                .reject_img2
                            }
                            style={{
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                              backgroundColor: "#ddd",
                            }}
                          >
                            <p style={{ textAlign: "center" }}>
                              No Photo Added
                            </p>
                          </div>
                        )}
                        {this.state.bookingDetailsDataPrev.booking_data
                          .reject_img3 ? (
                          <img
                            src={
                              this.state.bookingDetailsDataPrev.booking_data
                                .reject_img3
                            }
                            style={{
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                              backgroundColor: "#ddd",
                            }}
                          >
                            <p style={{ textAlign: "center" }}>
                              No Photo Added
                            </p>
                          </div>
                        )}
                        {this.state.bookingDetailsDataPrev.booking_data
                          .reject_img4 ? (
                          <img
                            src={
                              this.state.bookingDetailsDataPrev.booking_data
                                .reject_img4
                            }
                            style={{
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                              backgroundColor: "#ddd",
                            }}
                          >
                            <p style={{ textAlign: "center" }}>
                              No Photo Added
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}











              {this.state.bookingDetailsDataPrev.booking_data.status ===
              "closed" ? (
                <div style={{ ...card }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <p id="font" style={cardHeading}>
                      Acceptance Info
                    </p>
                  </div>

                  <p
                    id="font"
                    style={{
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                  >
                    Rating -{" "}
                    {
                      this.state.bookingDetailsDataPrev.booking_data
                        .booking_closure_rating
                    }
                  </p>
                  <p
                    id="font"
                    style={{
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                  >
                    Feedback -{" "}
                    {
                      this.state.bookingDetailsDataPrev.booking_data
                        .booking_closure_feedback
                    }
                  </p>
                </div>
              ) : null}
              {/* {this.state.bookingDetailsDataPrev.booking_data.status ===
                "completed" ||
              this.state.bookingDetailsDataPrev.booking_data.status ===
                "closed" ? (
                <div style={{ ...card }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <p id="font" style={cardHeading}>
                      Acceptance Info
                    </p>
                  </div>

                  <p
                    id="font"
                    style={{
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                  >
                    Rating -{" "}
                    {
                      this.state.bookingDetailsDataPrev.booking_data
                        .booking_closure_rating
                    }
                  </p>
                  <p
                    id="font"
                    style={{
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                  >
                    Feedback -{" "}
                    {
                      this.state.bookingDetailsDataPrev.booking_data
                        .booking_closure_feedback
                    }
                  </p>
                </div>
              ) : null} */}
            </div>
            <div
              style={{
                width: "50%",
                // backgroundColor: 'lightgreen',
                display: "flex",
                flexDirection: "column",
                padding: 10,
              }}
            >
              <div style={card1}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <p style={cardHeading}>Booking Address</p>
                </div>
                <p style={infoHead}>
                  {this.state.bookingDetailsDataPrev.booking_data.address_city}
                </p>
                <p
                  style={{
                    fontSize: 18,
                  }}
                >
                  {this.state.bookingDetailsDataPrev.booking_data.address_line1}
                </p>
                <p
                  style={{
                    fontSize: 18,
                    marginBottom: 0,
                  }}
                >
                  State -{" "}
                  {this.state.bookingDetailsDataPrev.booking_data.address_state}
                </p>
                <p
                  style={{
                    fontSize: 18,
                  }}
                >
                  Zip - {this.state.bookingDetailsDataPrev.booking_data.zipcode}
                </p>
                <p
                  style={{
                    fontSize: 18,
                    fontWeight: "bold",
                  }}
                >
                  Contact - @{this.state.bookingDetailsDataPrev.userdata.name}{" "}
                  (M-
                  {this.state.bookingDetailsDataPrev.userdata.phone})
                </p>
              </div>

              {this.state.bookingDetailsDataPrev.status === "closed" ||
              this.state.bookingDetailsDataPrev.status === "completed" ||
              this.state.bookingDetailsDataPrev.status === "denied" ||
              this.state.bookingDetailsDataPrev.status ===
                "denied-confirmed" ? (
                <div style={card2}>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p style={cardHeading}>Completion Info</p>
                    </div>
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <p style={{ fontSize: 18 }}>
                      <span style={{ fontWeight: "bold" }}>
                        Notes / Instructions
                      </span>
                    </p>
                    <p style={{ fontSize: 18 }}>
                      {this.state.bookingDetailsDataPrev.booking_data
                        .completion_note || "No notes"}
                    </p>
                  </div>
                  <div style={{ marginTop: 66 }}>
                    <p style={{ fontSize: 18 }}>
                      <span style={{ fontWeight: "bold" }}>
                        Uploaded Photos
                      </span>
                    </p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        alignItems: "center",
                        borderRadius: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",

                          justifyContent: "space-evenly",
                          width: "100%",
                          alignItems: "center",
                        }}
                      >
                        {this.state.bookingDetailsDataPrev.booking_data
                          .completion_img1 ? (
                          <img
                            src={
                              this.state.bookingDetailsDataPrev.booking_data
                                .completion_img1
                            }
                            style={{
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                              backgroundColor: "#ddd",
                            }}
                          >
                            <p style={{ textAlign: "center" }}>
                              No Photo Added
                            </p>
                          </div>
                        )}
                        {this.state.bookingDetailsDataPrev.booking_data
                          .completion_img2 ? (
                          <img
                            src={
                              this.state.bookingDetailsDataPrev.booking_data
                                .completion_img2
                            }
                            style={{
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                              backgroundColor: "#ddd",
                            }}
                          >
                            <p style={{ textAlign: "center" }}>
                              No Photo Added
                            </p>
                          </div>
                        )}
                        {this.state.bookingDetailsDataPrev.booking_data
                          .completion_img3 ? (
                          <img
                            src={
                              this.state.bookingDetailsDataPrev.booking_data
                                .completion_img3
                            }
                            style={{
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                              backgroundColor: "#ddd",
                            }}
                          >
                            <p style={{ textAlign: "center" }}>
                              No Photo Added
                            </p>
                          </div>
                        )}
                        {this.state.bookingDetailsDataPrev.booking_data
                          .completion_img4 ? (
                          <img
                            src={
                              this.state.bookingDetailsDataPrev.booking_data
                                .completion_img4
                            }
                            style={{
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "7rem",
                              width: "7rem",
                              marginTop: 5,
                              borderRadius: 10,
                              backgroundColor: "#ddd",
                            }}
                          >
                            <p style={{ textAlign: "center" }}>
                              No Photo Added
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

            

              {/* <div style={card}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }}>
                                        <p style={cardHeading}>Payment Method</p>
                                    </div>
                                    <p style={infoHead}>Card - {this.state.bookingDetailsDataPrev.userdata.brand}</p>
                                    <p style={{
                                        fontSize: 18
                                    }}>Card Number - **** **** **** {this.state.bookingDetailsDataPrev.userdata.last4}</p>
                                    <p style={{
                                        fontSize: 18
                                    }}>Expiry - {this.state.bookingDetailsDataPrev.userdata.exp_month}/{this.state.bookingDetailsDataPrev.userdata.exp_year}</p>
                                    <p style={{
                                        fontSize: 18
                                    }}>Amount Payable - ${this.state.bookingDetailsDataPrev.booking_value}</p>
                                </div> */}
              {this.state.bookingDetailsDataPrev.status == "requested" ||
              this.state.bookingDetailsDataPrev.status == "rescheduled-user" ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: 20,
                    marginTop: "auto",
                  }}
                >
                  <p
                    onClick={() =>
                      this.setState({
                        reject_booking_alert: true,
                      })
                    }
                    style={{
                      backgroundColor: "red",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      width: "100%",
                      margin: 10,
                      padding: 10,
                      color: "white",
                      fontSize: 18,
                      fontWeight: "700",
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    Reject
                  </p>

                  <p
                    onClick={() =>
                      this.setState({
                        accept_booking_alert: true,
                      })
                    }
                    style={{
                      backgroundColor: "#0078ff",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      width: "100%",
                      margin: 10,
                      padding: 10,
                      color: "white",
                      fontSize: 18,
                      fontWeight: "700",
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    Accept
                  </p>
                </div>
              ) : null}
              {this.state.bookingDetailsDataPrev.status == "confirmed" &&
              !this.state.sub_status &&
              this.checkIsBookingToday() ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "0 20px",
                  }}
                >
                  <p
                    onClick={() =>
                      // this.onMyWayPressed(this.data?.booking_id, "on-my-way")
                      this.setState({
                        on_my_way_alert: true,
                      })
                    }
                    style={{
                      backgroundColor: "#0078ff",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      width: "100%",
                      margin: 10,
                      padding: 10,
                      color: "white",
                      fontSize: 18,
                      fontWeight: "700",
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    On My Way
                  </p>
                </div>
              ) : null}
              {this.state.bookingDetailsDataPrev.status == "confirmed" &&
              this.state.sub_status == "on-my-way" &&
              this.checkIsBookingToday() ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "0 20px",
                  }}
                >
                  <p
                    onClick={() =>
                      // this.onMyWayPressed(this.data?.booking_id, "on-my-way")
                      this.setState({
                        started_job_alert: true,
                      })
                    }
                    style={{
                      backgroundColor: "#0078ff",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      width: "100%",
                      margin: 10,
                      padding: 10,
                      color: "white",
                      fontSize: 18,
                      fontWeight: "700",
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    Started the Job
                  </p>
                </div>
              ) : null}
              {this.state.bookingDetailsDataPrev.status == "confirmed" &&
              this.state.sub_status == "started-job" &&
              this.checkIsBookingToday() ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "0 20px",
                  }}
                >
                  <p
                    onClick={() =>
                      this.props.history.push(
                        `/provider/booking_complete/${this.state.bookingDetailsDataPrev.id}`,
                        {
                          bookingDetailsData: this.state.bookingDetailsDataPrev,
                        }
                      )
                    }
                    style={{
                      backgroundColor: "#0078ff",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      width: "100%",
                      margin: 10,
                      padding: 10,
                      color: "white",
                      fontSize: 18,
                      fontWeight: "700",
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    Mark as Completed
                  </p>
                </div>
              ) : null}
              {this.state.bookingDetailsDataPrev.status == "confirmed" &&
              !this.state.sub_status ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "0 20px",
                  }}
                >
                  <p
                    onClick={() =>
                      this.setState({
                        cancel_confirmed_booking_alert: true,
                      })
                    }
                    style={{
                      backgroundColor: "red",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      width: "100%",
                      margin: 10,
                      padding: 10,
                      color: "white",
                      fontSize: 18,
                      fontWeight: "700",
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </p>

                  <p
                    onClick={() =>
                      this.props.history.push(
                        `/provider/booking_reschedule/${this.state.bookingDetailsDataPrev.id}`,
                        {
                          bookingDetailsData: this.state.bookingDetailsDataPrev,
                        }
                      )
                    }
                    style={{
                      backgroundColor: "#0078ff",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      width: "100%",
                      margin: 10,
                      padding: 10,
                      color: "white",
                      fontSize: 18,
                      fontWeight: "700",
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                  >
                    Reschedule
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <AreYouSureAlert
          open={this.state.accept_booking_alert}
          title=""
          content={`You are about to Accept the ${
            this.state.bookingDetailsDataPrev.status == "requested"
              ? "Booking"
              : "Reschedule Request"
          }. Do you want to continue?`}
          close={() => this.setState({ accept_booking_alert: false })}
          handleYes={this.acceptBookingStart}
          handleNo={() => this.setState({ accept_booking_alert: false })}
        />
        <AreYouSureAlert
          open={this.state.reject_booking_alert}
          title=""
          // content='You are about to reject the booking. By rejecting the booking you will no longer be able to see it. Do you want to continue?'
          content={`${
            this.state.bookingDetailsDataPrev.status == "requested"
              ? "You are about to reject the booking. By rejecting the booking you will no longer be able to see it. Do you want to continue?"
              : this.state.bookingDetailsDataPrev.status == "rescheduled-user"
              ? "You are about to reject the reschedule request. By rejecting the reschedule request you will no long be able to see this booking. You can always accept the reschedule request then ask the customer to reschedule to another time that works for you. Do you want to continue?"
              : ""
          }`}
          close={() => this.setState({ reject_booking_alert: false })}
          handleYes={this.rejectBookingStart}
          handleNo={() => this.setState({ reject_booking_alert: false })}
        />
        <AreYouSureAlert
          open={this.state.cancel_confirmed_booking_alert}
          title=""
          content="You are about to cancel the booking. By Canceling this job you will no longer be able to see it. Do you want to continue?"
          close={() => this.setState({ cancel_confirmed_booking_alert: false })}
          handleYes={this.cancelConfirmedBookingStart}
          handleNo={() =>
            this.setState({ cancel_confirmed_booking_alert: false })
          }
        />
        <AreYouSureAlert
          open={this.state.on_my_way_alert}
          title=""
          content="This will notify the client you are on the way. Do you want to continue?"
          close={() => this.setState({ on_my_way_alert: false })}
          handleYes={() =>
            this.updateSubstatus(
              this.state.bookingDetailsDataPrev.booking_id,
              "on-my-way"
            )
          }
          handleNo={() => this.setState({ on_my_way_alert: false })}
        />
        <AreYouSureAlert
          open={this.state.started_job_alert}
          title=""
          content="This confirms you are starting the job. If you need to adjust pricing you can do so in the booking on the top right. IMPORTANT, YOU MUST DO ANY PRICE ADJUSTMENTS BEFORE STARTING WORK AND HAVE CUSTOMER APPROVAL TO GET PAID. Do you want to continue?"
          close={() => this.setState({ started_job_alert: false })}
          handleYes={() =>
            this.updateSubstatus(
              this.state.bookingDetailsDataPrev.booking_id,
              "started-job"
            )
          }
          handleNo={() => this.setState({ started_job_alert: false })}
        />
      </div>
    );
  }
}

// const mapStateToProps = ({ settings }) => {
//     return {
//         colors: settings.colors
//     };
// };
const composedComponent = compose(
  withStyles(styles),
  withTheme(),
  connect(null, actions)
);

export default withRouter(composedComponent(ProviderBookingDetailsNew));



// WEBPACK FOOTER //
// ./src/views/ProviderScreensNew/ProviderBookingDetailsNew.jsx